// extracted by mini-css-extract-plugin
export default {"overlay":"ErrorOverlay_overlay__vcc27","item":"ErrorOverlay_item__XY7Tu","label":"ErrorOverlay_label__bGGdp","reason":"ErrorOverlay_reason__fRhgr"};